import { useState } from 'react'
import { useControl, Marker, ControlPosition } from 'react-map-gl'
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder'
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css'

const accessToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN as string

type GeocoderProps = {
  position: ControlPosition
}

export const Geocoder: React.FC<GeocoderProps> = (props: GeocoderProps) => {
  const [markerLocation, setMarkerLocation] = useState<GeoJSON.Position | null>(null)

  useControl(
    () => {
      const geocoder = new MapboxGeocoder({
        marker: false,
        accessToken: accessToken
      })
      geocoder.on('result', event => {
        const result: MapboxGeocoder.Result | undefined = event.result
        const location = result && (result.center || (result.geometry?.type === 'Point' && result.geometry.coordinates))
        if (location) {
          setMarkerLocation(location)
        } else {
          setMarkerLocation(null)
        }
      })
      return geocoder
    },
    {
      position: props.position
    }
  )
  return markerLocation ? <Marker longitude={markerLocation[0]} latitude={markerLocation[1]} /> : null
}
